import { baseURL } from '@/config/env'
import { apiRequest } from '@amplify3/duplo-back-end'

export const getJobInfos = async ({ jobId }: { jobId?: string }) => {
  if (jobId !== undefined) {
    const data = await apiRequest({ baseURL, url: `/job/${jobId}` })
    return data?.job_infos
  }
  return undefined
}
